import { useQuery } from '@tanstack/react-query';

import { getUnreadCount } from '@/api/notifications';
import { useOptionalNotificationStream } from '@/context/NotificationStreamContext';
import { notificationKeys } from './keys';

export const UNREAD_POLL_INTERVAL_MS = 60_000;

/**
 * The unread bell count. It polls every 60 seconds only while the shared stream is
 * not open; an open stream keeps the count fresh through cache updates.
 */
export function useUnreadCount(enabled = true) {
  const stream = useOptionalNotificationStream();
  const streamOpen = stream?.state === 'open';

  return useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: getUnreadCount,
    enabled,
    refetchInterval: streamOpen ? false : UNREAD_POLL_INTERVAL_MS,
  });
}
